import React, { useRef } from 'react';
import ReactInputMask from 'react-input-mask';
import { TrashIcon } from '@heroicons/react/24/outline';
import DialogShell from './dialog-shell';
import { TWButton, TWInput, FieldLabel } from '../../../../components/ui';

const CustomerEditDialog = ({
  open,
  onClose,
  form,
  errors,
  loading,
  onChange,
  onSubmit,
  onDelete,
}) => {
  const cancelRef = useRef(null);

  return (
    <DialogShell
      open={open}
      onClose={onClose}
      maxWidth="sm:max-w-2xl"
      initialFocus={cancelRef}
    >
      <div className="px-6 pt-6">
        <h2 className="text-lg font-bold text-slate-900 dark:text-slate-100">
          Edit Customer
        </h2>
        <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
          Update the customer profile attached to this order.
        </p>
      </div>

      <div className="space-y-4 px-6 py-5">
        <TWInput
          label="Name"
          value={form.name}
          onChange={(e) => onChange(e.target.value, 'name')}
          placeholder="John Doe"
          error={errors.name ? 'Name can not be empty' : undefined}
        />
        <TWInput
          label="Email"
          value={form.email}
          onChange={(e) => onChange(e.target.value, 'email')}
          placeholder="customer@example.com"
        />
        <div>
          <FieldLabel htmlFor="cust-phone">Phone</FieldLabel>
          <ReactInputMask
            id="cust-phone"
            mask="(999) 999 9999"
            maskPlaceholder=" "
            value={form.phone}
            onChange={(e) => onChange(e.target.value, 'phone')}
            className="block w-full rounded-md border border-slate-200 bg-white px-3 py-2 text-sm tabular-nums text-slate-900 placeholder:text-slate-400 shadow-sm transition focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500 dark:border-slate-600 dark:bg-slate-900 dark:text-slate-100 dark:placeholder:text-slate-500 dark:focus:border-sky-400 dark:focus:ring-sky-400"
          />
        </div>
      </div>

      <div className="flex flex-wrap items-center justify-between gap-3 border-t border-slate-100 bg-slate-50 px-6 py-4 dark:border-slate-700 dark:bg-slate-900/40">
        <TWButton
          variant="danger"
          icon={TrashIcon}
          label="Delete"
          loading={loading.deleteLoading}
          disabled={loading.deleteLoading}
          onClick={onDelete}
        />
        <div className="flex items-center gap-2">
          <TWButton
            ref={cancelRef}
            label="Cancel"
            disabled={loading.upsertLoading}
            onClick={onClose}
          />
          <TWButton
            variant="primary"
            label="Save Changes"
            loading={loading.upsertLoading}
            disabled={loading.upsertLoading}
            onClick={onSubmit}
          />
        </div>
      </div>
    </DialogShell>
  );
};

export default CustomerEditDialog;
